export default __webpack_public_path__ + "static/media/jigsaw.b09409e4.png";